import React, { Component } from 'react'
import './banner.scss'
import Cross from '../images/cross.svg'

class Banner extends Component {
  constructor() {
    super()
    this.state = {
      displayInfo: true,
    }
  }

  render() {
    return this.state.displayInfo ? (
      <div className="banner-info">
        <div className="banner-info-button">
          <button onClick={() => this.setState({ displayInfo: false })}>
            <img src={Cross} />
          </button>
        </div>
        <div className="banner-info-content">
          <p>
            <strong>Précautions liées au Covid 19</strong>
          </p>
          <p>
            La période actuelle nous impacte tous et nous invite à rester
            prudents. Sur autorisation gouvernementale, les consultations au
            cabinet sont autorisées.Afin de nous protéger, du gel
            hydroalcoolique est mis à disposition et vous êtes priés de vous
            munir d’un masque. Il est également possible d’adapter le cadre de
            nos entretiens momentanément et de convenir, pour ceux qui le
            souhaitent, de visio-consultations. Je reste à votre disposition
            pour de plus amples informations. Prenez soin de vous et de vos
            proches.
          </p>
        </div>
      </div>
    ) : null
  }
}

export default Banner



// WEBPACK FOOTER //
// ./src/modules/banner.js